import Stack from '@mui/material/Stack'
import React from 'react'

import T from 'T'

import { DAMAGE_RESPONSIBLE_OPTIONS, DAMAGE_TYPE_OPTIONS, EXCEPTION_FORM_FIELD } from '../constants'
import ExceptionToggleField from '../ExceptionToggleField'

import type { ExceptionFormValues } from '../constants'
import type { Control } from 'react-hook-form'

// Damage: what was damaged (description) + who is responsible (responsibleParty).
// The signature pad was dropped per product along with the Signature exception type.
type DamageFieldsProps = {
  control: Control<ExceptionFormValues>
}

const DamageFields: React.FC<DamageFieldsProps> = ({ control }) => (
  <Stack gap={2}>
    <ExceptionToggleField control={control} label={T.DAMAGE_TYPE} name={EXCEPTION_FORM_FIELD.DESCRIPTION} options={DAMAGE_TYPE_OPTIONS} />
    <ExceptionToggleField
      control={control}
      label={T.RESPONSIBLE_PARTY}
      name={EXCEPTION_FORM_FIELD.RESPONSIBLE_PARTY}
      options={DAMAGE_RESPONSIBLE_OPTIONS}
    />
  </Stack>
)

export default DamageFields
